export default __webpack_public_path__ + "static/tek_bg_01-4f2489bc3521d04846dc2c8d189efa5a.webp";